/**
 * Tailwind classes for settings.color_code values (customer status, call status, etc.).
 */
export function getSettingColorClass(colorCode?: string | null): string {
  if (!colorCode) {
    return 'bg-gray-100 text-gray-800 border-gray-300';
  }
  const colorMap: Record<string, string> = {
    RED: 'bg-red-100 text-red-800 border-red-300',
    WHITE: 'bg-gray-100 text-gray-800 border-gray-300',
    GREEN: 'bg-green-100 text-green-800 border-green-300',
    SKY: 'bg-cyan-100 text-cyan-800 border-cyan-300',
    YELLOW: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    ORANGE: 'bg-orange-100 text-orange-800 border-orange-300',
  };
  return colorMap[colorCode.toUpperCase()] || 'bg-gray-100 text-gray-800 border-gray-300';
}
